import { Box, Button, Grid, Tooltip } from "@mui/material";
import { DiscoverTabView, DiscoverViewContext } from "contexts/DiscoverView";
import { OrganizationUserContext } from "contexts/Organization";
import { TrackedCreatorsContext } from "contexts/TrackedCreators";
import { useContext } from "react";

import { trackEvent } from "utils/tracking";
import { usePageSize } from "utils/usePageSize";

import SidebarIcon, { SidebarIconName } from "./icons";
import { getStyles } from "./styles";

function HomeSideBar() {
  const { hasBanner } = usePageSize();
  const { currentOrg } = useContext(OrganizationUserContext);
  const { discoverTab, tabWidth, setDiscoverTab, setOpenVaSettings } =
    useContext(DiscoverViewContext);
  const { setTrackedCreatorSideBar } = useContext(TrackedCreatorsContext);

  const tabOpen = discoverTab !== null;
  const styles = getStyles(tabOpen ? `${tabWidth}px` : "0px", hasBanner);

  const renderButton = (
    tab: DiscoverTabView,
    tooltip: string,
    icon: SidebarIconName,
    iconColor?: string,
  ) => {
    const handleClick = () => {
      trackEvent("Discover Sidebar Clicked", { tab });
      if (tab === DiscoverTabView.VA_SETTINGS) {
        setDiscoverTab(null);
        setOpenVaSettings(true);
        trackEvent("VA Settings Page Opened Settings");
      } else if (tab === discoverTab) {
        setDiscoverTab(null);
      } else {
        setDiscoverTab(tab);
        if (tab === DiscoverTabView.SAVED_BRANDS) {
          setTrackedCreatorSideBar(null);
        }
      }
    };

    const active = discoverTab === tab;
    return (
      <Tooltip title={tooltip} placement="left">
        <Button onClick={handleClick} sx={[active ? styles.active : {}]}>
          <Box sx={[styles.icon, iconColor ? { color: iconColor } : {}]}>
            <SidebarIcon name={icon} />
          </Box>
        </Button>
      </Tooltip>
    );
  };

  return (
    <Box sx={styles.root}>
      <Grid container justifyContent="center" flexDirection="column">
        {renderButton(
          DiscoverTabView.SAVED_BRANDS,
          "View Saved Brands",
          "bookmark",
        )}

        {renderButton(DiscoverTabView.TEMPLATES, "View Your Templates", "edit")}

        {renderButton(DiscoverTabView.METRICS, "View Your Metrics", "trend")}
        {renderButton(DiscoverTabView.USER_REQUESTS, "View Wishlist", "inbox")}
        {!currentOrg?.isBrand && (
          <>
            {renderButton(
              DiscoverTabView.CHAT,
              "AI Pitch Writer",
              "sparkle",
              "#6F4FBF",
            )}
            {renderButton(DiscoverTabView.ASSISTANT, "AI Assistant", "chat")}
          </>
        )}
      </Grid>
    </Box>
  );
}

export default HomeSideBar;
